.field {
  display: flex;
  flex-direction: column;

  .fieldWrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
}

.label {
  font-size: var(--haus-typography-body-font-size, 1rem);
  font-weight: var(--haus-typography-body-font-weight, 400);
  line-height: var(--haus-typography-body-line-height, 1.5);
  color: var(--haus-color-text, #000);
  font-family: var(--haus-typography-body-font-family, 'Inter, sans-serif');
}

.input,
.textarea {
  width: var(--haus-input-width, auto);
  padding: var(--haus-input-padding, var(--haus-spacing-sm, 0.75rem));
  font-family: var(--haus-typography-body-font-family, 'Inter, sans-serif');
  font-size: var(--haus-typography-body-font-size, 1rem);
  line-height: var(--haus-typography-body-line-height, 1.5);
  color: var(--haus-color-text, #000);
  background-color: var(--haus-input-background-color, #fff);
  border: var(--haus-input-border, 0.0625rem solid #ccc);
  border-radius: var(--haus-input-border-radius, 0.25rem);
  transition: var(--haus-transition, 0.2s ease-in-out);

  &:focus-visible {
    outline: var(--haus-input-focus-outline, 2px solid var(--haus-color-primary, #000));
    outline-offset: var(--haus-input-focus-outline-offset, 2px);
    border-color: var(--haus-input-focus-border-color, var(--haus-color-primary, #000));
    box-shadow: var(--haus-input-focus-box-shadow, 0 0 0 0.125rem rgba(0, 0, 0, 0.1));
  }

  &:disabled {
    background-color: var(--haus-input-disabled-background-color, #f5f5f5);
  }

  &::placeholder {
    color: var(--haus-input-placeholder-color, #999);
  }
}

.textarea {
  resize: var(--haus-input-textarea-resize, vertical);
  min-height: var(--haus-input-textarea-min-height, 6rem);
}

.error {
  font-size: var(--haus-typography-body-font-size, 1rem);
  font-weight: var(--haus-typography-body-font-weight, 400);
  line-height: var(--haus-typography-body-line-height, 1.5);
  color: var(--haus-color-error, #dc3545);
  font-family: var(--haus-typography-body-font-family, 'Inter, sans-serif');
}

.required {
  color: var(--haus-color-error, #dc3545);
}
